export default __webpack_public_path__ + "static/media/dg-icon.f7561e52.webp";